export default __webpack_public_path__ + "static/media/facebook-circle-fill.6073c004.svg";